import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxUnchecked = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0) scale(1.2632)",
		children: /* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 18,
			height: 18,
			rx: 4.5,
			stroke: "currentColor"
		})
	})]
});
const ForwardRef = forwardRef(SvgCheckboxUnchecked);
export default ForwardRef;
